export default {
    'loading': 'loading'
};
